import { createContext } from "react";
import {
  ShipmentConfirmContextValue,
  ShipmentDeleteContextValue,
  ShipmentDetailsContextValue,
} from "./types";

/* ===========================================================================
 * SHIPMENT DETAILS CONTEXT
 * ======================================================================== */

/*
  Provides detailed information for a single shipment.
  Exposes:
  - data: shipment details
  - loader: loading state
  - modalConfig: modal state for UI interactions
  - getShipmentDetails: function to refresh data
  - acr: ask collection reservation flag
  - setAcr: setter for acr
  - setModalConfig: setter for modalConfig
*/
export const ShipmentDetailsContext = createContext<
  ShipmentDetailsContextValue | undefined
>(undefined);

/* ===========================================================================
 * SHIPMENT DELETE CONTEXT
 * ======================================================================== */

/*
  Provides state and functions for deleting shipments.
  Exposes:
  - data: array of shipment IDs to delete
  - loader: loading state during deletion
  - deleteShipments: function to trigger deletion
  - callback: optional function called after deletion
 */
export const ShipmentDeleteContext = createContext<
  ShipmentDeleteContextValue | undefined
>(undefined);

/* ===========================================================================
 * SHIPMENT CONFIRM CONTEXT
 * ======================================================================== */

/*
  Provides state and functions for confirming shipments.
  Exposes:
  - data: array of shipment IDs to confirm
  - loader: loading state during confirmation
  - confirmShipments: function to trigger confirmation
  - callback: optional function called after confirmation
*/
export const ShipmentConfirmContext = createContext<
  ShipmentConfirmContextValue | undefined
>(undefined);
